import { render, staticRenderFns } from "./NewsInfo.vue?vue&type=template&id=07e847ba&scoped=true"
import script from "./NewsInfo.vue?vue&type=script&lang=js"
export * from "./NewsInfo.vue?vue&type=script&lang=js"
import style0 from "./NewsInfo.vue?vue&type=style&index=0&id=07e847ba&prod&lang=less&scoped=true"
import style1 from "./NewsInfo.vue?vue&type=style&index=1&id=07e847ba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07e847ba",
  null
  
)

export default component.exports